module.exports = __webpack_public_path__ + "static/Search-Panel-c0ec3da501ae5a07e87a6452f0018383.png";